// ── Adapter HTTP do IMktWebhookGateway ────────────────────────────
// Implementa o disparo do webhook do MKT (n8n) via fetch. É a ÚNICA camada
// que conhece a URL base, credenciais Basic e o timeout do POST.

import type { IMktWebhookGateway, MktAction } from '@modules/mkt';

const MKT_WEBHOOK_BASE = (
  process.env.REACT_APP_N8N_MKT_WEBHOOK_URL ||
  'https://n8n.2.empreenderdinheiro.com.br/webhook/450261b7-5dc3-4fc5-8598-da77a52d0e9e/mkt'
).replace(/\/$/, '');

const MKT_TIMEOUT_MS = 8000;

// Reaproveita as credenciais Basic dos webhooks de reunião (se houver).
const buildBasicAuth = (): string | null => {
  const user = process.env.REACT_APP_N8N_MEET_WEBHOOK_USER;
  const pass = process.env.REACT_APP_N8N_MEET_WEBHOOK_PASS;
  if (!user || !pass || typeof btoa !== 'function') return null;
  return btoa(`${user}:${pass}`);
};

export class MktWebhookClient implements IMktWebhookGateway {
  sendConversion = async (action: MktAction, body: Record<string, unknown>): Promise<void> => {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    const auth = buildBasicAuth();
    if (auth) headers.Authorization = `Basic ${auth}`;

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), MKT_TIMEOUT_MS);

    await fetch(`${MKT_WEBHOOK_BASE}/${action}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
      signal: controller.signal,
    }).finally(() => clearTimeout(timeout));
  };
}
